export default class PostView {

    static keyPrefix = 'postViewTime:';

    static postClosed(postid) {
        localStorage.setItem(this.getKey(postid), new Date().toUTCString());
    }

    static lastViewed(postid) {
        return localStorage.getItem(this.getKey(postid)) || null;
    }

    static getKey(postid) {
        return this.keyPrefix + postid;
    }

}